const getRecentFiles = state => state.welcome.recentFiles;
const getExampleFiles = state => state.welcome.exampleFiles;
const getCustomTemplates = state => state.welcome.customTemplates;

const getShowUpgradeWizard = state => state.welcome.showUpgradeWizard;
const getIncomingUpgradeData = state => state.welcome.incomingUpgradeData;
const getShowTemplateWizard = state => state.welcome.showTemplateWizard;

const getShowLoadingFile = state => state.welcome.showLoadingFile;

export default {
  getRecentFiles,
  getExampleFiles,
  getCustomTemplates,
  getShowUpgradeWizard,
  getIncomingUpgradeData,
  getShowTemplateWizard,
  getShowLoadingFile
};
